import { render, staticRenderFns } from "./ProgramView.vue?vue&type=template&id=32315e69"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports